import { ISlotGameSettings } from '@cgs/machines';

export const santaGameSettings: ISlotGameSettings = {
  paytable: {
    resourcePath: 'paytable/html',
    sections: [],
  },
  cheat: {
    url: 'configs/cheat.json',
  },
  symbols: {
    simpleIcons: {
      '1': 'scatter.png',
      '2': 'wild.png',
      '3': 'h1.png',
      '4': 'h2.png',
      '5': 'elf.png',
      '6': 'whip.png',
      '7': 'money.png',
      '8': 'bear.png',
      '9': 'doll.png',
      '10': 'man.png',
      '11': 'robot.png',
    },
    specialIcons: {
      SCATTER: 'scatter.png',
      WILD: 'wild.png',
    },
    extraIcons: {},
    maxIconId: 20,
  },
  paylines: {
    game: [],
    dev: [],
  },
  config: {
    url: 'configs/game-config.json',
  },
};
